import classNames from 'classnames';
import React from 'react';
import Button, { ButtonProps } from '../Button';

export interface IconButtonProps extends ButtonProps {
  icon: string;
  size?: IconButtonProps["height"];
}

const SIZE_MAP = {
  "2s": "28px",
  "s": "32px",
  "m": "36px",
  "l": "40px",
  "2l": "48px",
  "3l": "56px",
};

const IconButton: React.FC<IconButtonProps> = ({
  className,
  icon,
  size = "m",
  height,
  ...props
}) => {
  // widthとheightを同一にする
  const width = SIZE_MAP[size];

  return (
    <Button
      className={classNames("uc-button", "icon-button", className)}
      leftIcon={icon}
      height={size}
      isRound
      style={{ width }}
      {...props}
    />
  );
};

export default IconButton;